import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject, combineLatest, of } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LocalStorageKeys } from 'src/app/shared/models/local-storage.model';
import { AdvanceService } from 'src/app/shared/services/advance.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Advance } from 'src/app/shared/models/advance.model';
import { EmployeesService } from 'src/app/shared/services/employees.service';
import { map, tap, take } from 'rxjs/operators';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { Employee } from 'src/app/shared/models/employee.model';
import { UserService } from 'src/app/shared/services/user.service';
import { SelectOption } from 'src/app/shared/components/form-control/select/select.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-advance',
  templateUrl: './advance.component.html',
})
export class AdvanceComponent implements OnInit {
  employees$: Observable<Employee[]>;
  isThisNewAdvancePage = true;
  newAdvanceFormGroup: FormGroup;
  hasStaticAdvance$;
  currentUserId;
  advanceOptions: SelectOption[];
  // advance$;

  selectsLoading = {
    employee: true,
    type: false,
  };

  types = [
    // {
    //   name: 'Stała',
    //   value: 'static',
    // },
    {
      name: 'Dodatkowa',
      value: 'additional',
    },
  ];

  constructor(
    private employeeService: EmployeeService,
    private advanceService: AdvanceService,
    private alert: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.currentUserId = this.userService.getCurrentUserId();
    this.createFormGroup();
    this.employees$ = this.employeeService.activeEmployees$.pipe(
      tap(v => (this.selectsLoading.employee = false))
    );
    this.setupHasStaticAdvanceObservable();
  }

  createFormGroup() {
    this.newAdvanceFormGroup = this.fb.group({
      name: [null, [Validators.required]],
      value: [null, [Validators.required]],
      // description: [null, [Validators.required]],
      delegationNumber: [],
      type: [null, [Validators.required]],
      employee: [null, [Validators.required]],
    });
  }

  setupHasStaticAdvanceObservable() {
    this.hasStaticAdvance$ = combineLatest([
      this.newAdvanceFormGroup.get('employee').valueChanges,
      this.employees$,
    ]).pipe(
      map(([employeeId, employees]) =>
        employees.find(employee => employee.id === parseInt(employeeId, 10))
      ),
      tap(employee => {
        employee
          ? this.newAdvanceFormGroup.get('type').setValue('additional')
          : this.newAdvanceFormGroup.get('type').setValue(null);
      }),
      map(employee => (employee ? employee.hasStaticAdvance : false))
    );
  }

  submit() {
    const transformedForm = {
      ...this.newAdvanceFormGroup.value,
      employee: parseInt(this.newAdvanceFormGroup.get('employee').value, 10),
    };
    const advance = Advance.adapt(transformedForm);
    this.advanceService.createAdvance(advance).subscribe(response => {
      // this.alert.setMessage('Poprawnie utworzono zaliczkę');
      this.toastrService.success('Poprawnie utworzono zaliczkę');
      this.router.navigate(['advances/employees']);
    });
  }
}
